import React from 'react';
import './App.css';
import Todo from "./components/Todo";
import "materialize-css/dist/css/materialize.min.css";

function App() {
  return (
    <div className="App">
        <Todo/>
    </div>
  );
}

export default App;
